<template>
  <div>
    <WordBookBadge />
    <TabList />
  </div>
</template>
<script>
import TabList from "./tab/TabList"
import WordBookBadge from "./wordBookBadge/WordBookBadgeList"
export default {
    components: {
      TabList,
      WordBookBadge,
    }
}
</script>